module.exports = __webpack_public_path__ + "img/access_bank.fd803cc4.svg";